import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { RequestServiceQuoteComponent } from './request-service-quote.component'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { I18nModule, ConfigModule } from '@spartacus/core'
import { NgSelectModule } from '@ng-select/ng-select'
import { environment } from '../../../environments/environment'

@NgModule({
  declarations: [RequestServiceQuoteComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    I18nModule,
    NgSelectModule,
    ConfigModule.withConfig({
      i18n: {
        backend: {
          loadPath:
            environment.deployPath + '/assets/i18n-assets/{{lng}}/{{ns}}.json',
        },
        chunks: {
          common: ['serviceQuote'],
        },
      },
    }),
  ],

  providers: [],
})
export class RequestServiceQuoteModule {}
